// Gallery photo data.
// Photos are hosted externally on the photographer's personal RIT web space.
// Kept as external URLs by design (not localized) - see project notes.
const BASE_URL = 'https://csh.rit.edu/~jays';

const sampleNumbers = [
  2, 3, 4, 6, 9, 11, 12, 14, 15, 16, 18, 20, 21, 23, 31, 33, 34, 35, 36, 37,
  38, 39, 40, 41, 42, 43, 1, 5, 7, 8, 10, 13, 17, 19, 22, 24, 26, 27, 30, 32,
];

export const photos = sampleNumbers.map((n, index) => ({
  id: index,
  src: `${BASE_URL}/sample${n}.jpg`,
  alt: `Photo ${index + 1}`,
}));

export const heroBackground = `${BASE_URL}/bkgrnd2.jpg`;
